<script>
export default {
  props: {
    state: Object
  },
  data(){
    return{
      boostrapTooltipInstance: null
    }
  },
  methods: {
    hasTooltip(){
      return typeof this.state.message === 'string' && this.state.message.length > 0
    },
    // initTooltip(){
    //   this.boostrapTooltipInstance?.dispose();
    //   setTimeout(function (){
    //     this.boostrapTooltipInstance = new bootstrap.Tooltip(this.$refs.badge)
    //   }.bind(this), 100)
    // }
  },
  // watch: {
  //   state: function(newVal, oldVal) { // watch it
  //     this.initTooltip();
  //   }
  // },
  // mounted() {
  //   this.initTooltip();
  // },
}
</script>

<template>
  <span ref="badge" class="badge text-wrap" :class="`badge-${state.group_style}`" v-if="state"
        :data-bs-toggle="this.hasTooltip() ? 'tooltip' : null"
        :data-bs-title="state.message"
        :data-bs-html="true"


  ><i :class="state.group_icon"></i> {{ state.group_name }}</span>

</template>